import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import parking from "../../../Assets/Projects/IoT/parkir.png";

function SmartParking() {
  return (
    <ProjectDetailCard
      title="Smart Parking System for Santiago Bernabéu Stadium"
      image={parking}
      screenshots={[parking, parking, parking]}
      description="
      Smart Parking System for Santiago Bernabéu Stadium is an Internet of Things (IoT) solution developed to improve parking management through real-time monitoring and automation. The system utilizes sensors to detect vehicle occupancy in each parking space and transmits the data to a centralized platform, allowing users to instantly view available parking slots. By integrating IoT technology with an interactive monitoring dashboard, the system helps reduce traffic congestion, minimizes parking search time, and enhances the overall parking experience for stadium visitors.
      "
      technologies={[
        "ESP32",
        "Arduino",
        "IoT",
        "C++",
        "Firebase",
        "Wi-Fi",
        "Embedded System",
        "Real-Time Monitoring",
        "HTML5",
        "CSS3",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          {/* <img src={parking} alt="gallery1" />
          <img src={parking} alt="gallery2" />
          <img src={parking} alt="gallery3" /> */}
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default SmartParking;
